import React, { useState } from 'react';
import { useRootStore } from 'store/rootStore';
import { FileUpload, InputText, useQueryParams } from '@insurancemenu/imenu-components-lib';
import { AcceptedFiles } from '@insurancemenu/imenu-components-lib/dist/types/FileUpload';
import { ModalType } from 'global/utils/ModalsHelper';
import { observer } from 'mobx-react-lite';
import ActionModal from 'components/common/modals/ActionModal';
import { UPLOAD_FILE_TYPES } from '@insurancemenu/imenu-components-lib/dist/components/FileUpload';
import { toJS } from 'mobx';
import { createStyles } from './styles';

export interface AddCustomLinkModalProps {
  onUpdate: (portfolioId: string) => void;
}

const AddCustomLinkModal = observer(({ onUpdate }: AddCustomLinkModalProps): JSX.Element => {
  const classes = createStyles();
  const {
    uploadFileModalStore: {
      loading,
      isFileUploadReset,
      uploadFileForm,
      currentPortfolio,
      showUploadFileModal,
      closeUploadModal,
      uploadDocument,
    },
  } = useRootStore();

  const { portfolioId, portfolioName } = toJS(currentPortfolio);
  const query = useQueryParams();
  const cartId = query.get('cartId') || '';

  const [file, setFile] = useState<AcceptedFiles>({});

  const onModalClose = (): void => {
    setFile({});
    closeUploadModal();
  };

  const onFileUpload = async (): Promise<void> => {
    await uploadDocument(file, cartId);
    onModalClose();
    // Update portfolio to show uploaded link
    onUpdate(portfolioId);
  };

  const modalContent = (
    <div className={classes.modalContent}>
      <InputText
        value={uploadFileForm.fields.name.value}
        onChange={uploadFileForm.onFieldChange}
        label="Dynamic link name"
        name="name"
        maxLength={20}
        className={classes.linkNameInput}
        validationMessage={uploadFileForm.fields.name.unpassedValidationMsg || ''}
        validationPassed={!uploadFileForm.fields.name.unpassedValidationMsg}
      />
      <div className={classes.fileUpload}>
        <FileUpload
          allowMultipleFiles={false}
          fileMimeTypes={[
            UPLOAD_FILE_TYPES.xlsx,
            UPLOAD_FILE_TYPES.xls,
            UPLOAD_FILE_TYPES.pdf,
            UPLOAD_FILE_TYPES.csv,
            UPLOAD_FILE_TYPES.tsv,
            UPLOAD_FILE_TYPES.doc,
            UPLOAD_FILE_TYPES.docx,
          ]}
          messageForRejectedFiles="Please upload only valid files"
          shouldBeReset={isFileUploadReset}
          onChange={setFile}
        />
      </div>
    </div>
  );

  return (
    <div>
      <ActionModal
        show={showUploadFileModal}
        title="Upload File"
        subtitle={
          <span>
            Upload file and enter the name you want this file to be saved. <br />
            This file will be displayed in the dynamic links section for your
            <br />
            <b className={classes.currentPortfolioName}>{portfolioName}</b> plan.
          </span>
        }
        modalType={ModalType.NO_ICON}
        closeButtonText="Cancel"
        onClose={onModalClose}
        actionButtonText="Upload"
        onAction={onFileUpload}
        loading={loading}
        modalContent={modalContent}
        className={classes.uploadModal}
        isValid={Object.keys(file).length === 1 && uploadFileForm.isFormValid()}
      />
    </div>
  );
});

export default AddCustomLinkModal;
